"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var bramble_1 = require("./bramble");
// works
function pointVsRect(point, rect) {
    return (point.x >= rect.x &&
        point.y >= rect.y &&
        point.x < rect.x + rect.width &&
        point.y < rect.y + rect.height);
}
// works
function rectVsRect(rectA, rectB) {
    return (rectA.x < rectB.x + rectB.width &&
        rectA.x + rectA.width > rectB.x &&
        rectA.y < rectB.y + rectB.height &&
        rectA.y + rectA.height > rectB.y);
}
// works
// returns false if no collision occurred, otherwise it returns an object
// containing the results of the collision
// { near, far, normal }
function lineVsRect(line, rect) {
    var from = bramble_1.vec2.create(line.from.x, line.from.y);
    var to = bramble_1.vec2.create(line.to.x, line.to.y);
    var dir = bramble_1.vec2.clone(to);
    dir.subtract(from);
    var invdir = {
        x: 1.0 / dir.x,
        y: 1.0 / dir.y
    };
    var timeNear = {
        x: (rect.x - line.from.x) * invdir.x,
        y: (rect.y - line.from.y) * invdir.y
    };
    var timeFar = {
        x: (rect.x + rect.width - line.from.x) * invdir.x,
        y: (rect.y + rect.height - line.from.y) * invdir.y
    };
    if (isNaN(timeNear.x) || isNaN(timeNear.y)) {
        return false;
    }
    if (isNaN(timeFar.x) || isNaN(timeFar.y)) {
        return false;
    }
    // sort the distances
    var tempNear = __assign({}, timeNear);
    var tempFar = __assign({}, timeFar);
    if (tempNear.x > tempFar.x) {
        timeNear.x = tempFar.x;
        timeFar.x = tempNear.x;
    }
    tempNear = __assign({}, timeNear);
    tempFar = __assign({}, timeFar);
    if (tempNear.y > tempFar.y) {
        timeNear.y = tempFar.y;
        timeFar.y = tempNear.y;
    }
    // no collision detected
    if (timeNear.x > timeFar.y || timeNear.y > timeFar.x) {
        return false;
    }
    var hitNear = Math.max(timeNear.x, timeNear.y);
    var hitFar = Math.min(timeFar.x, timeFar.y);
    // abort if ray is facing away from our object
    if (hitFar < 0) {
        return false;
    }
    // abort if the ray does not reach the object
    if (hitNear > 1) {
        return false;
    }
    // abort if the ray's first collision is behind us
    if (hitNear < 0) {
        return false;
    }
    // construct a vector to hold the normal of the surface
    var normal = bramble_1.vec2.create(0, 0);
    if (timeNear.x > timeNear.y) {
        if (invdir.x < 0) {
            normal.x = 1;
            normal.y = 0;
        }
        else {
            normal.x = -1;
            normal.y = 0;
        }
    }
    else if (timeNear.x < timeNear.y) {
        if (invdir.y < 0) {
            normal.x = 0;
            normal.y = 1;
        }
        else {
            normal.x = 0;
            normal.y = -1;
        }
    }
    else if (timeNear.x === timeNear.y) {
        if (invdir.x < 0 && invdir.y < 0) {
            normal.x = -1;
            normal.y = 1;
        }
        else if (invdir.x > 0 && invdir.y < 0) {
            normal.x = 1;
            normal.y = 1;
        }
        else if (invdir.x < 0 && invdir.y > 0) {
            normal.x = -1;
            normal.y = -1;
        }
        else if (invdir.x > 0 && invdir.y > 0) {
            normal.x = 1;
            normal.y = -1;
        }
    }
    // collided with the object!
    return {
        normal: normal,
        near: bramble_1.vec2.create(from.x + hitNear * dir.x, from.y + hitNear * dir.y),
        far: bramble_1.vec2.create(from.x + hitFar * dir.x, from.y + hitFar * dir.y),
        timeOfCollision: hitNear
    };
}
// a dynamic rect is one that can move - has a velocity
// static rect doesn't move
function dynamicRectVsStaticRect(dynamicRect, staticRect) {
    // assume no collision if the dynamic rect is not moving
    // avoiding using length here because it calculates a square root
    if (dynamicRect.velocity.x === 0 && dynamicRect.velocity.y === 0) {
        return false;
    }
    var halfWidth = dynamicRect.width / 2;
    var halfHeight = dynamicRect.height / 2;
    var clone = bramble_1.vec2.clone(dynamicRect.position);
    clone.add(dynamicRect.velocity);
    clone.x += dynamicRect.width / 2;
    clone.y += dynamicRect.height / 2;
    var line = {
        from: {
            x: dynamicRect.position.x + halfWidth,
            y: dynamicRect.position.y + halfHeight
        },
        to: clone
    };
    var rect = {
        x: staticRect.position.x - halfWidth,
        y: staticRect.position.y - halfHeight,
        width: staticRect.width + dynamicRect.width,
        height: staticRect.height + dynamicRect.height
    };
    return lineVsRect(line, rect);
}
// Compute the value of a point on a cubic Bezier curve at parameter t
function cubicBezierPoint(P0, P1, P2, P3, t) {
    var x = (1 - t) * (1 - t) * (1 - t) * P0.x +
        3 * (1 - t) * (1 - t) * t * P1.x +
        3 * (1 - t) * t * t * P2.x +
        t * t * t * P3.x;
    var y = (1 - t) * (1 - t) * (1 - t) * P0.y +
        3 * (1 - t) * (1 - t) * t * P1.y +
        3 * (1 - t) * t * t * P2.y +
        t * t * t * P3.y;
    return bramble_1.vec2.create(x, y);
}
// Compute the tangent of the curve at parameter t
function cubicBezierTangent(P0, P1, P2, P3, t) {
    var x = 3 * (1 - t) * (1 - t) * (P1.x - P0.x) +
        6 * (1 - t) * t * (P2.x - P1.x) +
        3 * t * t * (P3.x - P2.x);
    var y = 3 * (1 - t) * (1 - t) * (P1.y - P0.y) +
        6 * (1 - t) * t * (P2.y - P1.y) +
        3 * t * t * (P3.y - P2.y);
    return bramble_1.vec2.create(x, y);
}
// Helper function to find the roots of a cubic polynomial using Cardano's formula
function findCubicRoots(A, B, C, D) {
    if (Math.abs(A) < 1e-10) {
        return findQuadraticRoots(B, C, D);
    }
    var a = B / A;
    var b = C / A;
    var c = D / A;
    var p = (3 * b - a * a) / 3;
    var q = (2 * a * a * a - 9 * a * b + 27 * c) / 27;
    var discriminant = (q * q) / 4 + (p * p * p) / 27;
    var roots = [];
    if (discriminant > 0) {
        var u = Math.cbrt(-q / 2 + Math.sqrt(discriminant));
        var v = Math.cbrt(-q / 2 - Math.sqrt(discriminant));
        roots.push(u + v - a / 3);
    }
    else if (discriminant === 0) {
        var u = Math.cbrt(-q / 2);
        roots.push(2 * u - a / 3);
        roots.push(-u - a / 3);
    }
    else {
        var r = Math.sqrt((-p * p * p) / 27);
        var phi = Math.acos(-q / (2 * r));
        roots.push(2 * Math.cbrt(r) * Math.cos(phi / 3) - a / 3);
        roots.push(2 * Math.cbrt(r) * Math.cos((phi + 2 * Math.PI) / 3) - a / 3);
        roots.push(2 * Math.cbrt(r) * Math.cos((phi + 4 * Math.PI) / 3) - a / 3);
    }
    return roots.filter(function (t) { return t >= 0 && t <= 1; });
}
// Helper function to find the roots of a quadratic polynomial
function findQuadraticRoots(A, B, C) {
    var discriminant = B * B - 4 * A * C;
    if (discriminant < 0) {
        return [];
    }
    else if (discriminant === 0) {
        return [-B / (2 * A)];
    }
    else {
        var sqrtDiscriminant = Math.sqrt(discriminant);
        return [
            (-B + sqrtDiscriminant) / (2 * A),
            (-B - sqrtDiscriminant) / (2 * A)
        ];
    }
}
// Find intersection between a ray (defined by two points) and a cubic Bezier curve
function lineVsCubicBezierCurve(P0, P1, P2, P3, R0, R1) {
    var intersections = [];
    // Coefficients of the cubic Bezier curve
    var ax = -P0.x + 3 * P1.x - 3 * P2.x + P3.x;
    var ay = -P0.y + 3 * P1.y - 3 * P2.y + P3.y;
    var bx = 3 * P0.x - 6 * P1.x + 3 * P2.x;
    var by = 3 * P0.y - 6 * P1.y + 3 * P2.y;
    var cx = -3 * P0.x + 3 * P1.x;
    var cy = -3 * P0.y + 3 * P1.y;
    var dx = P0.x;
    var dy = P0.y;
    // Coefficients of the ray
    var rx = R1.x - R0.x;
    var ry = R1.y - R0.y;
    var ex = R0.x;
    var ey = R0.y;
    // Construct the cubic equation: At^3 + Bt^2 + Ct + D = 0
    var A = ax * ry - ay * rx;
    var B = bx * ry - by * rx;
    var C = cx * ry - cy * rx;
    var D = (dx - ex) * ry - (dy - ey) * rx;
    var roots = findCubicRoots(A, B, C, D);
    // Check valid t values and compute intersections
    roots.forEach(function (t) {
        var intersection = cubicBezierPoint(P0, P1, P2, P3, t);
        var tangent = cubicBezierTangent(P0, P1, P2, P3, t);
        var angleRadians = Math.atan2(tangent.y, tangent.x);
        var angleDegrees = angleRadians * (180 / Math.PI);
        var tempvec = bramble_1.vec2.fromDegrees(angleDegrees);
        var normal = bramble_1.vec2.create(tempvec.y, -tempvec.x);
        // Calculate the distance along the ray
        var dx = intersection.x - R0.x;
        var dy = intersection.y - R0.y;
        var distanceToIntersection = Math.sqrt(dx * dx + dy * dy);
        var rayLength = Math.sqrt(rx * rx + ry * ry);
        var remainderLength = rayLength - distanceToIntersection;
        // Ensure the intersection point lies within the ray segment
        var rayParam = (intersection.x - ex) / rx;
        var rayParamY = (intersection.y - ey) / ry;
        if ((rayParam >= 0 && rayParam <= 1) ||
            (rayParamY >= 0 && rayParamY <= 1)) {
            intersections.push({
                point: bramble_1.vec2.create(intersection.x, intersection.y),
                distance: distanceToIntersection,
                remainderLength: remainderLength,
                angleRadians: angleRadians,
                angleDegrees: angleDegrees,
                direction: bramble_1.vec2.fromDegrees(angleDegrees),
                normal: normal
            });
        }
    });
    return intersections;
}
exports.default = {
    dynamicRectVsStaticRect: dynamicRectVsStaticRect,
    rectVsRect: rectVsRect,
    lineVsRect: lineVsRect,
    pointVsRect: pointVsRect,
    lineVsCubicBezierCurve: lineVsCubicBezierCurve
};
